<template>
    <div>
        <el-row>
            <el-col :span="2">
                <el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>
            </el-col>
            <el-col :span="2" offset="1">
                选择平台
            </el-col>
            <el-col :span="2">
                <el-select v-model="tabActive" placeholder="请选择" @change="initSubTabMobule(tabActive)">
                    <el-option
                            v-for="item in tabTreeData"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-col>
            <el-col :span="2" offset="15">
                <el-button type="success" size="mini" @click="handleEdit('')" class="header-btn">新增</el-button>
            </el-col>
        </el-row>
        <el-tabs v-model="tabSubActive" tab-position="left" @tab-click="subTabHandleClick">
            <template v-for="item in subTabList">
                <el-tab-pane :label="item.name" :name="item.id.split('_')[2]">
                    <el-table :data="moduleList" stripe border center :size="GCONFIG.styleTableSize">
                        <el-table-column type="index" label="序号" width="60"></el-table-column>
                        <el-table-column prop="pageCode" label="页面编号"></el-table-column>
                        <el-table-column prop="pageName" label="页面名称"></el-table-column>
                        <el-table-column prop="webFlag" label="webFlag"></el-table-column>
                        <el-table-column prop="createTime" label="创建时间"></el-table-column>
                        <el-table-column prop="createUserName" label="创建人"></el-table-column>
                        <el-table-column label="操作" fixed="right" width="180">
                            <template slot-scope="scope">
                                <el-button-group>
                                    <el-button type="primary" size="mini" @click="handleEdit(scope.row.buildPageId)">
                                        修改
                                    </el-button>
                                    <el-button type="warning " size="mini" @click="handleDel(scope.row.buildPageId)">
                                        删除
                                    </el-button>
                                </el-button-group>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
            </template>
        </el-tabs>

        <el-dialog title="新增/修改" :visible.sync="dialogFormVisible" center>
            <el-form :model="form" label-width="80px">
                <el-form-item label="页面名称">
                    <el-input v-model="form.pageName"></el-input>
                </el-form-item>
                <el-form-item label="平台" v-show="editFlag">
                    <el-select v-model="form.platformId" placeholder="平台" :disabled="platformDisabled">
                        <el-option v-for="item in tabTreeData"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="parseInt(item.id)">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="页面类型">
                    <el-select v-model="form.pageType" clearable placeholder="页面类型">
                        <el-option v-for="item in pageTypeData"
                                   :key="item.dictionaryKey"
                                   :label="item.dictionaryName"
                                   :value="parseInt(item.dictionaryKey)">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="栏目类型">
                    <el-select v-model="form.navType" clearable placeholder="栏目类型">
                        <el-option v-for="item in navTypeData"
                                   :key="item.dictionaryKey"
                                   :label="item.dictionaryName"
                                   :value="parseInt(item.dictionaryKey)">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="存储类型">
                    <el-select v-model="form.saveType" clearable placeholder="存储类型">
                        <el-option v-for="item in saveTypeData"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>

                <!--<el-form-item label="示意图">-->
                <!--需要上传组件-->
                <!--</el-form-item>-->
                <el-form-item label="前端标识">
                    <el-input type="input" placeholder="请输入内容" v-model="form.webFlag"></el-input>
                </el-form-item>

                <el-form-item label="内容">
                    <el-input type="textarea" :rows="10" placeholder="请输入内容" v-model="form.pageContent"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button @click="dialogFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="save(form)">确 定</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {
        getBuildPageList,
        getBuildPageTree,
        getValidDictionaryList,
        getPlatformList,
        getbuildpage,
        saveBuildPage,
        deleteBuildPage
    } from '../../api/api'
    import ElCol from "element-ui/packages/col/src/col";

    //定义组件
    export default{
        components: {ElCol}, data(){
            return {
                getBuildPageList: [],
                pageTypeData: [],
                platformData: [],
                navTypeData: [],
                saveTypeData: [{id: 1, name: "oss"}, {id: 2, name: "本地"}],
                loading: true,
                platformId: 0,
                navType: 0,
                selectValue: 0,
                editFlag: false,
                dialogFormVisible: false,
                form: {
                    "pageName": "",
                    "pageType": "",
                    "navType": "",
                    "platformId": "",
                    "saveType": "",
                    "imageUrl": "",
                    "pageContent": "",
                    "buildPageId": 0,
                    "webFlag": ""
                },
                defaultProps: {
                    children: 'children',
                    label: 'name'
                },
                formInline: {
                    "job_name": "",
                    "job_group": "",
                },
                platformDisabled: false,
                tabActive: '1',
                tabSubActive: '1',
                subTabList: []
            }
        },
        computed: {
            tabTreeData: function () {
                return this.$store.getters.getIndexModuleTabList
            },
            moduleList: function () {
                return this.$store.getters.getIndexModuleList
            }
        },
        //挂载时候执行
        mounted(){
            let _this = this;
            //初始化首页数据

            this.$store.dispatch('initIndexModuleTabList').then((res) => {
                _this.subTabList = res.children[0].children;
                _this.tabActive = res.id == '1002' ? '21' : '1';
                _this.$store.dispatch('initIndexModuleList', {platformId: _this.tabActive, navType: _this.tabSubActive})

            });
        },

        methods: {
            //定义查询方法
            getList(platformId, navType){
                getBuildPageList({platformId: platformId, navType: navType}).then((res) => {
                    this.loading = false;
                    this.getBuildPageList = res.data.value;
                    //this.recordsTotal = res.data.total;
                })
            },
            initSubTabMobule(id){
                let _this = this;
                this.tabTreeData.forEach(function (item, index) {
                    if (item.id == id) {
                        _this.subTabList = item.children;
                        _this.subTabHandleClick()
                    }
                })
            },
            subTabHandleClick(){
                this.$store.dispatch('initIndexModuleList', {platformId: this.tabActive, navType: this.tabSubActive})
            },
            handleDel(id){
                let _this = this;
                this.$confirm('确定删除选中的行吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteBuildPage({buildPageId: id}).then((res) => {
                        if (res.data.status == 200) {
                            _this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            _this.subTabHandleClick()
                        } else {
                            _this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }

                    })
                }).catch(() => {
                    _this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            handleEdit(id){
                let _this = this;
                this.dialogFormVisible = true;
                this.editFlag = id == '' ? false : true;
                //得到实体
                this.$store.dispatch('initIndexBuildPageDetail', {buildPageId: id}).then((res) => {
                    console.log(res)
                    _this.pageTypeData = res.pageTypeData;
                    _this.navTypeData = res.navTypeData;
                    if (id != '') {
                        _this.form = res.page;
                        _this.platformDisabled = true;
                    } else {
                        _this.platformDisabled = false;
                    }

                })
            },
            save(data){
                //console.log(data);
                let _this = this;
                if (data.pageName == "") {
                    this.$message({
                        message: "页面名称必填",
                        type: 'error'
                    });
                    return;
                }
                if (this.editFlag && data.platformId == "") {
                    this.$message({
                        message: "平台必选",
                        type: 'error'
                    });
                    return;
                }
                if (data.pageType == "") {
                    this.$message({
                        message: "页面类型必选",
                        type: 'error'
                    });
                    return;
                }
                if (data.navType == "") {
                    this.$message({
                        message: "栏目类型必选",
                        type: 'error'
                    });
                    return;
                }
                if (data.saveType == "") {
                    this.$message({
                        message: "存储类型必选",
                        type: 'error'
                    });
                    return;
                }

                saveBuildPage(data).then((res) => {
                    console.log(res);
                    if (res.data.success) {
                        _this.$message({
                            message: res.data.message,
                            type: 'success'
                        });
                        _this.dialogFormVisible = false;
                        _this.subTabHandleClick()
                    } else {
                        _this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });

            },
            returnHistory(){
                window.history.go(-1)
            }
        }
    }

</script>


<style lang="scss" rel="stylesheet/scss" scoped>
    .header-return {
        margin-bottom: 20px;
        padding: 10px 20px;
    }

    .header-btn {
        float: right;
    }
</style>


// WEBPACK FOOTER //
// src/views/pageconfig/moduleConfig.vue